/* ========================================
 K7 CUSTOM SCRIPTS
 ======================================== */

(function K7Init() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', K7Init);
    return;
  }
})();
